import { BlockingInterfacesContext } from './context';
import { useContext, useEffect } from 'react';

export const useBlockingInterface = (blockingInterfaceId: string, isOpen: boolean): void => {
  const context = useContext(BlockingInterfacesContext);
  const registerBlockingInterface = context?.registerBlockingInterface;
  const unregisterBlockingInterface = context?.unregisterBlockingInterface;

  useEffect(() => {
    if (!isOpen || !registerBlockingInterface || !unregisterBlockingInterface) return;

    registerBlockingInterface(blockingInterfaceId);

    return () => {
      unregisterBlockingInterface(blockingInterfaceId);
    };
  }, [blockingInterfaceId, isOpen, registerBlockingInterface, unregisterBlockingInterface]);
};

export const useBlockingInterfaces = () => {
  const context = useContext(BlockingInterfacesContext);

  if (!context) {
    throw new Error('useBlockingInterfaces must be used within BlockingInterfacesProvider');
  }

  return context;
};